import { BASE_URL } from '../../Constants/constants';

const getAuthHeaders = () => {
    const token = localStorage.getItem('accessToken');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const supervisorService = {
    async getSupervisors() {
        const response = await fetch(`${BASE_URL}/supervisors/`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) {
            console.error('Response status:', response.status);
            console.error('Response details:', await response.text());
            throw new Error(`Failed to fetch supervisors: ${response.status}`);
        }
        return response.json();
    },

    async getSupervisorsForDropdown() {
        const response = await fetch(`${BASE_URL}/supervisors/dropdown`, {
            headers: getAuthHeaders()
        });
        if (!response.ok) {
            console.error('Response status:', response.status);
            console.error('Response details:', await response.text());
            throw new Error(`Failed to fetch supervisors for dropdown: ${response.status}`);
        }
        return response.json();
    },

    async createSupervisor(supervisor) {
        const response = await fetch(`${BASE_URL}/supervisors/`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(supervisor),
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to create supervisor: ${errorText}`);
        }
        return response.json();
    },

    async updateSupervisor(id, supervisor) {
        const response = await fetch(`${BASE_URL}/supervisors/${id}`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(supervisor),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to update supervisor: ${errorText}`);
        }
        return response.json();
    },

    async deleteSupervisor(id) {
        const response = await fetch(`${BASE_URL}/supervisors/${id}`, {
            method: 'DELETE',
            headers: getAuthHeaders()
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to delete supervisor: ${errorText}`);
        }
        return response.json();
    },

    async updateSupervisorStatus(id, isActive) {
        const response = await fetch(`${BASE_URL}/supervisors/${id}/status`, {
            method: 'PATCH',
            headers: getAuthHeaders(),
            body: JSON.stringify({ is_active: isActive }),
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to update supervisor status: ${errorText}`);
        }
        return response.json();
    }
};